import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submit', 'loadingIndicator', 'formSection']

  connect() {
    this.formSection = this.formSectionTarget
    this.element.addEventListener('submit', this.handleSubmit.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('submit', this.handleSubmit.bind(this))
  }

  handleSubmit(event) {
    if (!this.element.checkValidity()) {
      return
    }
    this.showLoading()
  }

  setFieldsDisabledSstate(isDisabled) {
    this.formSection.querySelectorAll('input, select').forEach(element => {
      element.disabled = isDisabled
    })
  }

  showLoading() {
    this.submitTarget.disabled = true
    this.submitTarget.classList.add('text-transparent')
    this.loadingIndicatorTarget.classList.remove('hidden')
    this.setFieldsDisabledSstate(true)
  }
}
